import React, { useState, useEffect, useMemo } from 'react';
import './style.scoped.css';
import Toolbar from 'src/components/Toolbar';
import TabBar from 'src/components/TabBar';
import InfoItem from 'src/components/InfoItem';
import PolicyCard from 'src/components/PolicyCard';

import { useHistory } from 'react-router-dom';
import UserInfoService from 'src/utils/UserInfoService';
import { useTranslation } from 'react-i18next';
import policySt, { PolicyStore } from 'src/stores/PolicyStore';
import { observer } from 'mobx-react-lite';
import Promotions from '../NewsAndPromotion/Promotions';
import News from '../NewsAndPromotion/News';
import PaymentEach from './PaymentEach';
import AutoPayment from './AutoPayment';
import { featureInDevelopment } from '../../utils';

const CARD_DETAILS = ['assuredName', 'sumAssured', 'polStatrtDat', 'policyTerm', 'payFrequency', 'periodicPremium', 'agentName', 'agentPhone', 'agentCode'];

interface PaymentOnlineObserverProps {
  policyStore?: PolicyStore;
}
const PaymentOnlineObserver = observer(({ policyStore } : PaymentOnlineObserverProps) => {
  const { t } = useTranslation();
  const history = useHistory();
  const [tab, setTab] = useState<number>(0);
  const [allPolicy, setAllPolicy] = useState([]);

  const listTab = useMemo(() => {
    return [
      { name: t('Thanh toán tự động') }, { name: t('Thanh toán từng lần') }
    ]
  }, [t]);

  const _handleClose = () => {
    history.push("/");
  };

  const _handleBack = () => {
    history.push("/");
  };

  const _handleChangeTab = (tabIndex: number) => {
    if(tabIndex == 1) {
      featureInDevelopment()
      return
    }
    setTab(tabIndex);
  };

  const _renderContent = () => {
    if (tab == 0) {
      return <AutoPayment />;
    }
    return <PaymentEach />;
  };

  return (
    <div className="screen-container bg-background ct-view fix-scroll">
      <Toolbar
        title={t('Đóng phí trực tuyến')}
        showClose={true}
        onClose={_handleClose}
        onBack={_handleBack}
      />
      <div className="screenContainerWithoutButton">
        <div>
          <div className="h-3" />
          <div className="px-4">
            <TabBar
              data={listTab}
              activeTab={tab}
              onChangeTab={_handleChangeTab}
              classes={['my-policy-tabItemActive', 'my-policy-tabItemInactive']}
            />
          </div>
        </div>
        {_renderContent()}
      </div>
    </div>
  );
});

const PaymentOnline = () => <PaymentOnlineObserver policyStore={policySt} />;
export default PaymentOnline;
